import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { RouteProps } from 'routes/Link';

import { Collapse, Skeleton, Row, Column, IconButton, Link } from 'components/Blocks';
import { ChevronUpIcon, ChevronDownIcon } from 'components/Icons';

import { IconBox } from './IconBox';
import { NumCount } from './NumCount';

import { useToggleV2 } from 'hooks';

import { GetLabelFn } from 'types/general';

interface CardGridProps {
  children?: ReactNode;
  title: string;
  loading: boolean;
  icon: ReactNode;
  items: Array<
    {
      getLabel: GetLabelFn;
      count: number;
      icon?: ReactNode;
    } & RouteProps
  >;
}

export function CardGrid({ items, loading, title, icon, children }: CardGridProps): JSX.Element {
  const { t } = useLang();

  const [open, openHandlers] = useToggleV2(true);

  return (
    <Column gap="2">
      <Row
        className="rounded-sm bg-[#344054] px-3 py-1 text-white dark:bg-card"
        justifyContent="space-between"
      >
        <h6 className="flex items-center gap-2 text-xl font-medium text-white">
          {icon}

          {title}
        </h6>

        <IconButton onClick={openHandlers.toggle}>
          {open ? <ChevronDownIcon /> : <ChevronUpIcon />}
        </IconButton>
      </Row>

      <Collapse expanded={open}>
        <div className="grid grid-cols-4 gap-4 tablet:grid-cols-2 small_phone:grid-cols-1">
          {children}

          {items.map(({ getLabel, count, icon: statusIcon, ...routeProps }, index) =>
            loading ? (
              <Skeleton key={`skeleton-${index}-${getLabel(t)}`} height={130} />
            ) : (
              <Link
                key={`${routeProps.to}${getLabel(t)}${index}`}
                className="flex h-[130px] flex-col justify-center gap-4 rounded-md border border-border p-4 transition-colors hover:bg-hover"
                {...routeProps}
              >
                <Row className="single" justifyContent="space-between" gap="2">
                  <p className="font-medium ">{getLabel(t)}</p>

                  <IconBox>{statusIcon}</IconBox>
                </Row>

                <NumCount count={count} />
              </Link>
            ),
          )}
        </div>
      </Collapse>
    </Column>
  );
}
